// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__1-KLZ","container":"Modal_container__3NR-c","closeBtn":"Modal_closeBtn__17Qg2"};